import { extractBrowsers } from '~/utils/browser'

const useBrowserDetection = () => {
  const isSafari = useState('is-safari', () => false)
  const isChrome = useState('is-chrome', () => false)
  const isFirefox = useState('is-firefox', () => false)
  const isEdge = useState('is-edge', () => false)

  if (import.meta.client) {
    const userAgent = navigator.userAgent
    const browsers = extractBrowsers(userAgent)

    isSafari.value = browsers.safari
    isChrome.value = browsers.chrome
    isFirefox.value = browsers.firefox
    isEdge.value = browsers.edge
  }

  return {
    isSafari,
    isChrome,
    isFirefox,
    isEdge,
  }
}

export default useBrowserDetection